import "./index.scss";
import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Space,
  Input,
  message,
  Tooltip,
  ConfigProvider,
} from "antd";
import wrapper from "./wrapper";
import { useGetState } from "ahooks";
import { CheckCircleFilled, CloseOutlined } from "@ant-design/icons";
import Api from "../../apis";
import zhCN from "antd/locale/zh_CN";

const AddAccountModal = (props) => {
  const [visible, setVisible] = useState(true);
  const [form] = Form.useForm();
  const [upLoading, setUpLoading, getUpLoading] = useGetState(false);
  const [isOk, setIsOk] = useState(false);

  const {
    /* 标题 */
    title,
    /* 关闭触发的回调 */
    onCancel,
    /* 销毁组件回调(高阶组件自定义) */
    closeDialog,
    /* 确定触发的回调 */
    onOk,
    /* 弹窗权值 */
    zIndex = 2001,
    itemInfo,
  } = props;

  const handleCancel = () => {
    onCancel && onCancel();
    setVisible(false);
    setTimeout(() => {
      closeDialog();
    }, 500);
  };

  const handleOk = () => {
    onOk && onOk();
    setVisible(false);
    setTimeout(() => {
      closeDialog();
    }, 500);
  };

  useEffect(() => {
    let obj = {
      web: itemInfo.web_name,
      account: null,
      password: null,
    };
    form.setFieldsValue(obj);
  }, [itemInfo]);

  //验证
  const onVerification = () => {
    if (getUpLoading()) {
      return;
    }
    if(isOk){
      return
    }
    form.validateFields().then((res) => {
      setUpLoading(true);

      Api.verifyAccountPassword({
        web_id: itemInfo.id,
        account: res.account,
        password: res.password,
      })
        .then((res) => {
          console.log(res);

          if (res.code === 200 && res.data.verify_pass) {
            setIsOk(true);
            message.success(res.message);
          } else {
            message.warning("验证失败，请检查账号和密码");
          }
          setUpLoading(false);
        })
        .catch((sea) => {
          setUpLoading(false);
        });
    });
  };

  //保存
  const onFinish = () => {
    if (getUpLoading()) {
      return;
    }
    // form.setFieldsValue(obj);
    form
      .validateFields()
      .then((res) => {
        setUpLoading(true);
        let params = {
          web_id: itemInfo.id,
          account: res.account,
          password: res.password,
        };
        Api.saveAccount(params).then((res) => {
          if (res.code === 200) {
            handleOk();
          } else {
            message.error(res.message);
          }
          setUpLoading(false);
        });
      })
      .catch((err) => {
        console.error(err);
        setUpLoading(false);
      });
  };

  // 自定义圆角配置
  const customBorderRadius = {
    // 设置选择框的圆角
    Select: {
      borderRadius: 4, // 正常状态圆角
    },
    Input: {
      borderRadius: 4, // 正常状态圆角
    },
    DatePicker: {
      borderRadius: 4, // 正常状态圆角
    },
    Button: {
      borderRadius: 4, // 正常状态圆角
    },
    Radio: {
      borderRadius: 4, // 正常状态圆角
    },
  };

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: "#0068B2",
        },
        components: customBorderRadius,
      }}
    >
      <Modal
        title={title}
        visible={visible}
        onCancel={handleCancel}
        //   onOk={handleOk}
        wrapClassName="addAccountModal"
        width={600}
        centered
        footer={null}
        maskClosable={false}
        zIndex={zIndex}
      >
        <div className="addAccountModalContent">
          <div className="addAccountModalContent-header">
            由于“{itemInfo.web_name}
            ”网站设有限制访问，需完成实名认证方可进行核查，为确保核查任务顺利完成，请您提供该网站的账号和密码。若未能提供，我们可能无法完成此项核查。
          </div>
          <div className="addAccountModalContent-tip">
            如为注册或忘记密码，请点击访问{itemInfo.web_name}{" "}
            <Button
              type="link"
              onClick={() => window.open(itemInfo.index_url, "_blank")}
            >
              注册账号
            </Button>
          </div>
          <Form
            name="layout-multiple-horizontal"
            layout="horizontal"
            form={form}
            style={{ width: "100%" }}
            onValuesChange={() => {
              setIsOk(false);
            }}
          >
            <Form.Item
              layout="vertical"
              label="网站"
              name="web"
              rules={[{ required: true }]}
              style={{ width: "100%" }}
            >
              <Input disabled={true} />
            </Form.Item>
            <Form.Item
              layout="vertical"
              label="账号/手机号"
              name="account"
              rules={[{ required: true }]}
            >
              <Input placeholder="请输入账号/手机号" allowClear />
            </Form.Item>
            <Form.Item
              layout="vertical"
              label="密码"
              name="password"
              rules={[{ required: true }]}
            >
              <Input.Password placeholder="请输入密码" allowClear />
            </Form.Item>
          </Form>
          <Space size="middle" align="center" direction="horizontal">
            <Button onClick={handleCancel}>暂不添加</Button>
            <Button
              color={isOk ? "green" : "primary"}
              variant="solid"
              icon={isOk ? <CheckCircleFilled /> : null}
              loading={upLoading}
              onClick={onVerification}
            >
              验证{isOk ? "通过" : "账号"}
            </Button>
            {isOk ? (
              <Button type="primary" loading={upLoading} onClick={onFinish}>
                保存
              </Button>
            ) : (
              <Tooltip title="请先验证账号后再添加">
                <Button type="primary" disabled={true}>
                  保存
                </Button>
              </Tooltip>
            )}
          </Space>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default wrapper(AddAccountModal);
